module.exports = __webpack_public_path__ + "img/ic_user.9ed8ef3f.svg";